import React, { useState } from "react";
import Start from "./components/Start";
import Content from "./components/Content";

const Main = () => {
  const [start, setStart] = useState(false);

  return (
    <div>

      {start ? 
      (
        <div>
          <Content setStart={setStart}/>
        </div>
      ) : 

      (
        <div>
          <Start setStart={setStart}/>
        </div>
      )}


    </div>
  );
};

export default Main;
